module.exports = __webpack_public_path__ + "img/header-ac.a9862bb0.jpeg";